export const whatWeAssume = {
  title: 'What we assume',
  text: `At Bankrate we strive to help you make smarter financial decisions.
  In addition to the details you provide and/or we extract from your document,
  we will use public information and a soft credit pull to identify monthly mortgage payments,
  remaining balance, loan term, and the interest rate for your property. If public information
  is not available, we use standard values in our calculations. Results do not account for all
  variables of your specific loan transaction, and provide a preliminary estimate for comparison
  purposes only.`,
}

export const monthlyPaymentTooltipContent = {
  currentLoan: {
    text: `The monthly payment displayed here may or may not include other
      factors such as lender fees, homeowner's insurance, property taxes,
      homeowner's association dues and private mortgage insurance.`,
  },
  otherOffers: {
    text: `The monthly payment displayed here represents your estimated principal
      and interest payment under the proposed loan terms. Your final calculated
      monthly payment will likely change from this estimate based on other
      factors such as homeowner's insurance, property taxes, homeowner's
      association dues and private mortgage insurance`,
  },
}

export const rateOriginTooltipContent = {
  text: `The details of your current loan were pulled from either: (a) the
    mortgage statement you uploaded to Bankrate or (b) publicly available
    information associated with your name and home address.`,
}
